export default "__VITE_ASSET__3e5f298b__"